import { userConstants } from '../constants';

export const userActions = {
    register
};

function register(user) {
    return dispatch => {
        dispatch(request(user));
        /*
        userService.register(user)
            .then(
                user => {
                    dispatch(success());
                    history.push('/login');
                    dispatch(alertActions.success('Registration successful'));
                },
                error => {
                    dispatch(failure(error.toString()));
                    dispatch(alertActions.error(error.toString()));
                }
            ); */
    };

    function request(user) { return { type: userConstants.REGISTER_REQUEST, user } }
}



// WEBPACK FOOTER //
// ./src/actions/user.actions.js